<template>
    <div class="sticker-css media-centre-css">
        <div class="file-manager-actions">
            <div class="w-100">
                <button type="button" class="btn btn-primary mr-2" data-toggle="modal" data-target="#upload"><i class="ion ion-md-cloud-upload"></i>&nbsp; Upload</button>
                <div class="btn-group mr-2">
                    <button type="button" class="btn btn-danger" :class="{'disabled': (sticker_array < 1)}" @click="delete_sticker()"><i class="far fa-trash-alt"></i>&nbsp; Delete</button>
                </div>
                <div class="btn-group mr-2" v-if="query_strings.archive == 0">
                    <button type="button" class="btn btn-warning" :class="{'disabled': (sticker_array < 1)}" @click="archive_sticker()"><i class="fas fa-folder-minus"></i>&nbsp; Archive</button>
                </div>
                <div class="btn-group mr-2" v-else>
                    <button type="button" class="btn btn-warning" :class="{'disabled': (sticker_array < 1)}" @click="archive_sticker()"><i class="fas fa-folder"></i>&nbsp; Unarchive</button>
                </div>
                <div class="ml-auto">                             
                    <div class="input-group position-relative">
                        <input type="text" v-model="query_strings.search" @change="get_query()" class="form-control" placeholder="Search Stickers" />
                        <div class="input-group-append">
                            <div class="input-group-text"><i class="fas fa-search"></i></div>
                        </div>
                        <i class="fas fa-times-circle position-absolute clear-input" v-if="query_strings.search" @click="query_strings.search = '', get_query()"></i>
                    </div>
                </div>
            </div>
        </div>

        <hr class="mt-3">

        <div v-if="stickers.length > 0">

            <div>
                <a href="#" @click.prevent="query_strings.archive = 1, get_query()" v-if="query_strings.archive == 0">View Archives</a>
                <a href="#" @click.prevent="query_strings.archive = 0, get_query()" v-else>View Stickers</a>
            </div>

            <p>
                Click on names or alt text to edit them.
            </p>

            <div class="file-manager-container file-manager-col-view mt-3">

                <div class="file-item" v-for="sticker in stickers">
                    <div class="file-item-select-bg bg-primary"></div>
                    <div class="d-flex w-100 align-items-center">
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" :value="sticker.id" v-model="sticker_array">
                            <span class="custom-control-label"></span>
                        </label>
                        <a href="#" class="far fas fa-folder-minus ml-auto text-info" @click.prevent="archive_sticker('single', sticker.id)" v-if="query_strings.archive == 0" title="Archive"></a>
                        <a href="#" class="far fas fa-folder ml-auto text-info" @click.prevent="archive_sticker('single', sticker.id)" title="Unarchive" v-else></a>
                        <a href="#" class="far fa-trash-alt ml-2 text-danger" @click.prevent="delete_sticker('single', sticker.id)" title="Delete"></a>
                    </div>     
                    <div class="file-item-img" :style="'background-image: url(' + sticker.images.png + ' );'"></div>
                    <div class="mt-2 text-left d-flex w-100 align-items-center">
                        <div class="input-text">
                            Sticker Name:
                        </div>
                        <input class="focus-input w-100" v-model="sticker.name" @change="update_sticker(sticker.id, sticker.name, sticker.link, sticker.alt)" placeholder="Enter sticker name" />
                    </div>
                    <div class="mt-2 text-left d-flex w-100 align-items-center">
                        <div class="input-text">
                            Sticker alt/title:
                        </div>
                        <input class="focus-input w-100" v-model="sticker.alt" @change="update_sticker(sticker.id, sticker.name, sticker.link, sticker.alt)" placeholder="Enter alt/title text" />
                    </div>
                </div>

            </div>

            <nav>
                <ul class="pagination flex-wrap">
                    <li class="page-item" v-for="page in page_info.last_page" v-if="page_info.last_page != 1" :class="{'active': (page == query_strings.page)}">
                        <a class="page-link" v-if="page == query_strings.page">{{page}}</a>
                        <a class="page-link" @click.prevent="query_strings.page = page, get_query()" href="#" v-else>{{page}}</a>
                    </li>
                </ul>
            </nav>

        </div>

        <div class="text-center mt-5" v-else-if="!loading">
            No results founds matching your query. <a href="#" @click.prevent="query_strings.page = 1, query_strings.archive = 0, query_strings.search = '', get_query()">Reset</a>
        </div>

        <div class="modal fade" id="upload" tabindex="-1" role="dialog" aria-labelledby="upload modal" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Upload Sticker</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label for="sticker">Sticker Name*</label>
                            <input type="text" class="form-control" id="sticker" placeholder="Sticker Name" v-model="sticker_file.name">
                        </div>
                        <div class="form-group">
                            <label for="sticker">Sticker Alt/Title</label>
                            <input type="text" class="form-control" id="sticker" placeholder="Sticker Alt/Title" v-model="sticker_file.alt">
                        </div>
                        <div class="custom-file">
                            <input type="file" class="custom-file-input" id="pngfile" @change="add_png" accept=".png">
                            <label class="custom-file-label" for="pngfile" v-if="!sticker_file.png.name">Choose png file*</label>
                            <label class="custom-file-label" for="pngfile" v-else>{{sticker_file.png.name}}</label>
                        </div>
                        <div class="custom-file mt-3">
                            <input type="file" class="custom-file-input" id="svgfile" @change="add_svg" accept=".svg">
                            <label class="custom-file-label" for="svgfile" v-if="!sticker_file.svg.name">Choose svg file*</label>
                            <label class="custom-file-label" for="svgfile" v-else>{{sticker_file.svg.name}}</label>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" data-dismiss="modal" :class="{'disabled': (sticker_file.name.length < 1 || !sticker_file.png.name || !sticker_file.svg.name)}" @click="upload_sticker">
                            Upload
                        </button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>

        <loader :loading="loading"></loader>

    </div>
</template>

<script>

import loader from './loader.vue';

export default {

    components:{
        loader
    },

    data() {
        return {
            stickers: [],
            page_info: [],
            query_strings: {
                page: 1,
                archive: 0,
                search: ''
            },

            sticker_file: {
                name: '',
                alt: '',
                png: false,
                svg: false,
            },

            new_sticker_name: '',

            sticker_array: [],

            loading: true,
        };
    },

    props: {
    },

    mounted(){
        const urlParams = new URLSearchParams(window.location.search);
        if(urlParams.get('page')){
            this.query_strings.page = urlParams.get('page');
        }
        if(urlParams.get('archive')){
            this.query_strings.archive = urlParams.get('archive');
        }
        if(urlParams.get('search')){
            this.query_strings.search = urlParams.get('search');
        }

        this.get_stickers();
    },

    methods: {
        get_stickers: function(){
            this.loading = true;
            axios.get('/media-centre/stickers/list',{
                params: {
                    page: this.query_strings.page,
                    archive: this.query_strings.archive,
                    search: this.query_strings.search,
                }
            })
            .then(function (response) {
                console.log(response);
                this.page_info = response.data.stickers;
                this.stickers = response.data.stickers.data;
                this.loading = false;
            }.bind(this))
            .catch(function (error) {
                // handle error
                alert(error);
                this.loading = false;
            })
        },

        add_png: function(e){
            this.sticker_file.png = e.target.files[0];
        },

        add_svg: function(e){
            this.sticker_file.svg = e.target.files[0];
        },

        upload_sticker: function(){
            let data = new FormData();

            data.append('name', this.sticker_file.name);
            data.append('alt', this.sticker_file.alt);
            data.append('png', this.sticker_file.png, this.sticker_file.png.name);
            data.append('svg', this.sticker_file.svg, this.sticker_file.svg.name);

            axios.post('/media-centre/stickers', data, {
                headers: {
                    'content-type': 'multipart/form-data',
                },
            })
            .then(function (response) {
                this.get_stickers();
                this.sticker_file.name = '';
                this.sticker_file.alt = '';
                this.sticker_file.png = false;
                this.sticker_file.svg = false;

                document.getElementById("pngfile").value = "";
                document.getElementById("svgfile").value = "";

            }.bind(this))
            .catch(function (error) {
                alert(error.response.data.errors.name[0]);
                this.get_stickers();
            }.bind(this))
        },

        update_sticker: function(id, sticker_name, sticker_alt){
            axios.patch('/media-centre/stickers/' + id,{
                name: sticker_name,
                alt: sticker_alt,
            })
            .then(function (response) {
                this.get_stickers();
            }.bind(this))
            .catch(function (error) {
                // handle error
                alert(error.response.data.errors.name[0]);
                this.get_stickers();
            }.bind(this))
        },

        delete_sticker: function(single, id){
            if(single){
                this.sticker_array = [id];
            }
            axios.delete('/media-centre/stickers', {
                data: {
                    id: this.sticker_array,
                }
            })
            .then(function (response) {
                this.get_stickers();
                this.sticker_array = [];
            }.bind(this))
            .catch(function (error) {
                // handle error
                alert(error.response.data.errors.id[0]);
                this.get_stickers();
            }.bind(this))
        },

        archive_sticker: function(single, id){
            if(single){
                this.sticker_array = [id];
            }
            axios.patch('/media-centre/stickers/archive', {
                id: this.sticker_array,                
            })
            .then(function (response) {
                this.get_stickers();
                this.sticker_array = [];
            }.bind(this))
            .catch(function (error) {
                // handle error
                alert(error.response.data.errors.id[0]);
                this.get_stickers();
            }.bind(this))
        },

        get_query: function(){
            let queryString = '';
            if(this.query_strings.page > 1){
                queryString += 'page=' + this.query_strings.page + '&';
            }
            if(this.query_strings.archive > 0){
                queryString += 'archive=' + this.query_strings.archive + '&';
            }
            if(this.query_strings.search.length > 0){
                queryString += 'search=' + this.query_strings.search + '&';
            }
            if(queryString.length > 0 ){
                queryString = '?' + queryString;
                queryString = queryString.substring(0, queryString.length - 1);

            }
            history.pushState({page: 0}, "", window.location.pathname + queryString);

            this.get_stickers();
        },
    },
};
</script>